import { render } from "./QuizComponent.vue?vue&type=template&id=358bd408&scoped=true"
import script from "./QuizComponent.vue?vue&type=script&lang=js"
export * from "./QuizComponent.vue?vue&type=script&lang=js"

import "./QuizComponent.vue?vue&type=style&index=0&id=358bd408&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358bd408"]])

export default __exports__